<template>
    <div class="base-basic">
        <!-- 页面标题 -->
        <van-nav-bar title="系统管理" fixed />
        <!-- 占位元素，避免内容被固定的导航栏遮挡 -->
        <div class="nav-bar-placeholder"></div>

        <!-- 页面主体内容 -->
        <div class="body-content">
            <!-- 筛选条件 -->
            <div class="filter-container">
                <van-cell-group inset>
                    <van-field v-model="filters.method" label="请求方法" placeholder="输入请求方法（GET/POST/PUT/DELETE等）" />
                    <van-field v-model="filters.url" label="请求URL" placeholder="输入请求URL，支持模糊匹配" />
                    <!-- <van-field
            v-model="filters.ip"
            label="客户端IP"
            placeholder="输入客户端IP地址"
          /> -->
                    <!-- <van-field
            v-model="filters.responseStatus"
            label="响应状态码"
            placeholder="输入响应状态码"
            type="number"
          /> -->
                    <van-field v-model="filters.userId" label="用户ID" placeholder="输入用户ID" type="number" />
                    <div class="filter-actions">
                        <van-button type="primary" @click="fetchLogs">查询日志</van-button>
                        <van-button type="default" @click="resetFilters">重置</van-button>
                    </div>
                </van-cell-group>
            </div>

            <!-- 日志列表 -->
            <div class="logs-container">
                <van-loading v-if="loading" type="spinner" size="40px" />
                <van-empty v-else-if="logs.length === 0" description="暂无数据" />
                <div v-else class="logs-list">
                    <div v-for="(log, index) in logs" :key="log.id" class="log-item">
                        <div class="log-header">
                            <div class="log-index">{{ index + 1 }}</div>
                            <div class="log-time">{{ formatDate(log.created_time) }}</div>
                        </div>
                        <div class="log-basic-info">
                            <div class="log-method" :class="getMethodClass(log.method)">{{ log.method }}</div>
                            <span class="log-info-item">
                                <span :class="getStatusCodeClass(log.response_status)">{{ log.response_status
                                    }}</span></span>

                            <span class="log-info-item"><span class="log-label">用户:</span> <span class="bule-font">{{
                                    log.user_id }}</span> {{ log.user_name || '-'
                                }}</span>
                            <span class="log-info-item"><span class="log-label">响应时间:</span> {{ log.response_time
                                }}ms</span>
                        </div>
                        <div class="log-url">
                            <span class="log-label">URL:</span> {{ log.url }}
                        </div>
                        <div class="log-trace-id">
                            <span class="log-label">Trace ID:</span> {{ log.trace_id }}
                        </div>
                        <div v-if="log.body" class="log-body">
                            <span class="log-label">Body:</span> {{ log.body }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- 分页 -->
            <div class="pagination-container">
                <van-pagination v-if="totalPages > 1" v-model="currentPage" :total-items="totalItems"
                    :items-per-page="pageSize" @change="handlePageChange" />
            </div>
        </div>
    </div>
</template>

<script>
import { ref, reactive, onMounted } from 'vue';
import { showFailToast } from 'vant';
import axios from '@/api/axios';

export default {
    name: 'SystemManagement',
    setup() {
        const loading = ref(false);
        const logs = ref([]);
        const currentPage = ref(1);
        const pageSize = ref(10);
        const totalItems = ref(0);
        const totalPages = ref(0);

        const filters = reactive({
            method: '',
            url: '',
            ip: '',
            responseStatus: '',
            userId: '',
            startDate: '',
            endDate: ''
        });

        // 获取日志数据
        const fetchLogs = async () => {
            loading.value = true;
            try {
                // 构建请求参数
                const params = {
                    page: currentPage.value,
                    limit: pageSize.value,
                    sortBy: 'created_time',
                    sortOrder: 'DESC'
                };

                // 添加非空过滤条件
                Object.keys(filters).forEach(key => {
                    if (filters[key]) {
                        params[key] = filters[key];
                    }
                });

                // 调用API获取日志数据
                const response = await axios.get('/api/api-logs', { params });

                if (response.data.success) {
                    logs.value = response.data.data.data;
                    totalItems.value = response.data.data.total;
                    totalPages.value = response.data.data.totalPages;
                } else {
                    showFailToast('获取日志失败');
                }
            } catch (error) {
                console.error('获取日志失败:', error);
                showFailToast('获取日志失败');
            } finally {
                loading.value = false;
            }
        };

        // 重置筛选条件
        const resetFilters = () => {
            Object.keys(filters).forEach(key => {
                filters[key] = '';
            });
            currentPage.value = 1;
            fetchLogs();
        };

        // 处理分页变化
        const handlePageChange = (page) => {
            currentPage.value = page;
            fetchLogs();
        };

        // 格式化日期
        const formatDate = (dateString) => {
            if (!dateString) return '-';
            const date = new Date(dateString)
            const timeStr = `${date.getUTCFullYear()}-${(date.getUTCMonth() + 1).toString().padStart(2, '0')}-${date.getUTCDate().toString().padStart(2, '0')} ${date.getUTCHours().toString().padStart(2, '0')}:${date.getUTCMinutes().toString().padStart(2, '0')}`;
            return timeStr;
        };

        // 获取请求方法样式
        const getMethodClass = (method) => {
            switch (method?.toUpperCase()) {
                case 'GET':
                    return 'method-get';
                case 'POST':
                    return 'method-post';
                case 'PUT':
                    return 'method-put';
                case 'DELETE':
                    return 'method-delete';
                default:
                    return 'method-default';
            }
        };

        // 获取响应状态码样式
        const getStatusCodeClass = (status) => {
            if (status >= 200 && status < 300) {
                return 'status-success';
            } else if (status >= 300 && status < 400) {
                return 'status-redirect';
            } else if (status >= 400 && status < 500) {
                return 'status-client-error';
            } else if (status >= 500) {
                return 'status-server-error';
            }
            return '';
        };

        // 组件挂载时获取数据
        onMounted(() => {
            fetchLogs();
        });

        return {
            loading,
            logs,
            currentPage,
            pageSize,
            totalItems,
            totalPages,
            filters,
            fetchLogs,
            resetFilters,
            handlePageChange,
            formatDate,
            getMethodClass,
            getStatusCodeClass
        };
    }
};
</script>

<style scoped>
/* 整体页面padding */
.base-basic {
    display: flex;
    flex-direction: column;
    padding-bottom: 70px;
    /* 为底部导航留出空间，与App.vue中定义的一致 */
    min-height: calc(100vh - 70px);
    /* 减去底部导航的高度 */
}

/* 导航栏占位元素样式 */
.nav-bar-placeholder {
    height: 46px;
    /* Vant导航栏默认高度 */
}

/* 页面主体内容 */
.body-content {
    margin-top: 40px;
    padding: 20px 16px;
    padding-bottom: 70px;
    /* 为底部导航预留空间，与App.vue中定义的一致 */
}

/* 筛选条件容器 */
.filter-container {
    margin-bottom: 20px;
}

/* 筛选按钮 */
.filter-actions {
    display: flex;
    justify-content: space-between;
    padding: 10px;
}

.filter-actions .van-button {
    flex: 1;
    margin: 0 5px;
}

/* 日志列表容器 */
.logs-container {
    margin-bottom: 20px;
    min-height: 300px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
}

/* 日志列表 */
.logs-list {
    width: 100%;
    text-align: left;
}

/* 日志项 */
.log-item {
    background-color: #fff;
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* 日志头部 */
.log-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

/* 日志序号 */
.log-index {
    font-weight: bold;
    color: #145294;
}

/* 日志时间 */
.log-time {
    font-size: 12px;
    color: #999;
}

/* 请求方法 */
.log-method {
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: bold;
    margin-right: 12px;
    color: #fff;
}

.method-get {
    background-color: #4CAF50;
}

.method-post {
    background-color: #2196F3;
}

.method-put {
    background-color: #FF9800;
}

.method-delete {
    background-color: #F44336;
}

.method-default {
    background-color: #9E9E9E;
}

/* 基本信息行 */
.log-basic-info {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 8px;
    font-size: 12px;
}

/* 信息项 */
.log-info-item {
    margin-right: 12px;
    margin-bottom: 4px;
}

/* 日志标签 */
.log-label {
    color: #999;
    margin-right: 4px;
}

/* 请求URL */
.log-url {
    font-size: 12px;
    color: #333;
    margin-bottom: 8px;
    word-break: break-all;
}

/* Trace ID */
.log-trace-id {
    font-size: 12px;
    color: #666;
    margin-bottom: 8px;
    word-break: break-all;
}

/* 请求Body */
.log-body {
    font-size: 12px;
    color: #666;
    margin-bottom: 8px;
    word-break: break-all;
}

/* 响应状态码样式 */
.status-success {
    color: #4CAF50;
}

.status-redirect {
    color: #FF9800;
}

.status-client-error {
    color: #F44336;
}

.status-server-error {
    color: #F44336;
}

.bule-font {
    color: #2196F3;
}

/* 分页容器 */
.pagination-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}
</style>